import React from 'react';
import { API_CONFIG } from '../api/config';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const token = localStorage.getItem('auth_token');

    if (!token) {
        window.location.href = API_CONFIG.ONBOARDING_URL;
        return null;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
